const queryToString = (params: object): string => {
    const keyPairs: string[] = [];

    for (const [ key, value ] of Object.entries(params)) {
        if (!value) continue;

        if (Array.isArray(value)) {
            keyPairs.push(`${key}=${value.join(',')}`);
        } else {
            keyPairs.push(`${key}=${value + ''}`);
        }
    }

    return keyPairs.join('&');
};

export default queryToString;